export const isEmptyNotZero = (item) => {
  if (item !== null && item !== undefined && item !== '')
    return true
  return false
}

export const queryFilterBuilder = (filters) => {
  const query = {ok: false, query: ''}
  Object.keys(filters).forEach(item => {
    const temp = filters[item]
    if (isEmptyNotZero(temp)) {
      const isEmpty = query.query === ''
      query.ok = true
      if (!isEmpty)
        query.query += '&'
      query.query += item + '=' + temp
    }
  })
  return query
}